export default __webpack_public_path__ + "static/media/keg-us-50.e86e6ded.png";